export default "__VITE_ASSET__0e7a9ae7__"